import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaRocket, FaArrowRight } from "react-icons/fa";

export default function CallToAction() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
  }, []);

  const handleGetStarted = () => {
    window.location.href = "/register";
  };

  return (
    <Wrapper id="callToAction">
      <div className="container">
        <CallToActionContainer>
          <LeftSection>
            <ImageWrapper >
              <StyledImage
                src={`${process.env.PUBLIC_URL}/unlockimg4.jpg`}
                alt="Opportunity Awaits"
              />
            </ImageWrapper>
          </LeftSection>

          <RightSection>
            <IconWrapper>
              <FaRocket />
            </IconWrapper>

            <Heading>
              <Subheading>Empowering Career Entry</Subheading>
              <MainTitle>Unlocking Potential Together</MainTitle>
            </Heading>

            <Description>
            Built for talents, we connect students and graduates with real-world experience through industry projects, 
            providing practical skills, mentorship, and career opportunities. Universities boost graduate employability, while companies gain access to fresh talent and innovative solutions. 
            One call is all it takes—our team is ready to deliver results.
            </Description>
            {!isLoggedIn && (
              <ActionButton onClick={handleGetStarted}>
                Get Started <FaArrowRight />
              </ActionButton>
            )}
          </RightSection>
        </CallToActionContainer>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 80px 0;
  background: linear-gradient(to bottom, #f9f9f9, #fff);
`;

const CallToActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  position: relative;
  height:100%;

  @media (max-width: 1024px) {
    width: 100%;
  }
  
  @media (max-width: 960px) {
    display: None;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 560px;
  object-fit: fill;
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 100%;
    align-items: center;
  }
`;

const IconWrapper = styled.div`
  width: 70px;
  height: 70px;
  background: rgba(46, 204, 113, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    color: #008394;
    font-size: 30px;
  }
`;

const Heading = styled.div`
  margin-bottom: 25px;
`;

const Subheading = styled.h4`
  font-size: 18px;
  color: #008394;
  margin-bottom: 10px;
  font-weight: 600;
`;

const MainTitle = styled.h2`
  font-size: 2.5rem;
  color: #333;
  line-height: 1.3;
  font-weight: 700;
`;

const Description = styled.p`
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 600px;

  @media (max-width: 1024px) {
    text-align: center;
  }
`;

const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 30px;
  background-color: #008394;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(46, 204, 113, 0.2);

  svg {
    transition: transform 0.2s ease;
  }

  &:hover {
    background-color: #eea746;
    transform: translateY(-3px);

    svg {
      transform: translateX(5px);
    }
  }
`;
